import { InsurersCodeEnum } from "../../../../../../enums/insurers-code.enum";
import { successNotification, warningNotification } from "../../../../../../services/notification";

export type Offer = {
  nomeSeguro: string;
  valorParcela: string;
  quantidadeParcela: number;
  rateCharge?: boolean;
}

export function adjustInsurerResponse(insurerResponse: any, insurer: string, values: Offer[]) {
  switch (insurer) {
    case InsurersCodeEnum.Garantti:
      values.forEach(offer => {
        const pos = insurerResponse.findIndex((i: any) => i.description ? ((i.description).toUpperCase() === offer.nomeSeguro) : ((i.plan_id).toUpperCase() === offer.nomeSeguro));
        insurerResponse[pos].rent_months_count = offer.quantidadeParcela
        insurerResponse[pos].residentialfee_assurance_month_amount = offer.valorParcela
        insurerResponse[pos].commercialfee_assurance_month_amount = offer.valorParcela
      })
      return insurerResponse;

    case InsurersCodeEnum.PortoEssencial:
      values.forEach(offer => {
        const pos = insurerResponse.findIndex((i: any) => i.nome_seguro === offer.nomeSeguro)
        insurerResponse[pos].quantidade_parcela = offer.quantidadeParcela
        insurerResponse[pos].valor_parcela = offer.valorParcela
        insurerResponse[pos].condicao_pagamento = "0" + String(offer.quantidadeParcela)
        insurerResponse[pos].premio_total = +offer.quantidadeParcela * +offer.valorParcela;
        insurerResponse[pos].premiobruto = +offer.quantidadeParcela * +offer.valorParcela;
      })
      return insurerResponse;
    case InsurersCodeEnum.Pottencial:
      values.forEach(offer => {
        const pos = insurerResponse.findIndex((i: any) => i.nome_seguro === offer.nomeSeguro)
        if (pos !== -1) {
          insurerResponse[pos].quantidadeParcela = offer.quantidadeParcela
          insurerResponse[pos].valorParcela = offer.valorParcela

        }
      })
      return toCamelCase(insurerResponse);

    case InsurersCodeEnum.Too:
    case InsurersCodeEnum.TokioMarine:
      values.forEach(offer => {
        const pos = insurerResponse.findIndex((i: any) => i.nome_seguro === offer.nomeSeguro)
        insurerResponse[pos].quantidadeParcela = offer.quantidadeParcela
        insurerResponse[pos].nomeSeguro = insurerResponse[pos].nome_seguro
        insurerResponse[pos].codigoPlano = insurerResponse[pos].codigo_plano
        insurerResponse[pos].valorParcela = offer.valorParcela
        insurerResponse[pos].commercialFee = insurerResponse[pos].commercial_fee
        insurerResponse[pos].codigoMultiplo = insurerResponse[pos].codigo_multiplo
        insurerResponse[pos].residentialFee = insurerResponse[pos].residential_fee
        insurerResponse[pos].codigoFormaPagamento = insurerResponse[pos].codigo_forma_pagamento
        delete insurerResponse[pos].nome_seguro
        delete insurerResponse[pos].codigo_plano
        delete insurerResponse[pos].commercial_fee
        delete insurerResponse[pos].codigo_multiplo
        delete insurerResponse[pos].residential_fee
        delete insurerResponse[pos].valor_parcela
        delete insurerResponse[pos].codigo_forma_pagamento
        delete insurerResponse[pos].quantidade_parcela
      })
      return insurerResponse;
    default:
      return insurerResponse;
  }
}


function toCamelCase(obj: any): any {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => toCamelCase(item));
  }

  return Object.keys(obj).reduce<Record<string, any>>((acc, key) => {
    const camelKey = key.replace(/_([a-z])/g, (_, letra) => letra.toUpperCase());
    acc[camelKey] = toCamelCase(obj[key]);
    return acc;
  }, {});
}